import { render, staticRenderFns } from "./historyResult.vue?vue&type=template&id=5e5258de&scoped=true"
import script from "./historyResult.vue?vue&type=script&lang=js"
export * from "./historyResult.vue?vue&type=script&lang=js"
import style0 from "./historyResult.vue?vue&type=style&index=0&id=5e5258de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5258de",
  null
  
)

export default component.exports